var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { chunk, flatten } from './array';
import { T, noop } from './util';
/**
 * Promise returning equivalent of `setTimeout`.
 *
 * @example
 * await delay(1000)
 * // => 1 second passed
 */
export var delay = function (ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
};
/**
 * Given a set of async functions, will return an async function that invokes the
 * given functions from right to left, passing the resolved data from the previous to
 * the next. The initial function can accept any number of arguments, the rest have
 * a fixed arity of 1.
 *
 * @example
 * const example = composeAsync(
 *   (y) => Promise.resolve(`${y}-baz`),
 *   (x) => Promise.resolve(`${x}-bar`),
 * )
 *
 * const result = await example('foo') // => foo-bar-baz
 */
export function composeAsync() {
    var fs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fs[_i] = arguments[_i];
    }
    var g = fs.pop() || noop;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return fs.reduceRight(function (prev, f) { return prev.then(f); }, Promise.resolve().then(function () { return g.apply(void 0, __spread(args)); }));
    };
}
/**
 * Async series map.
 * Invokes `f` for each `x` in `xs` in a series.
 *
 * @example
 * mapSeries([1, 2, 3], async () => { ... })
 */
export function mapSeriesAsync(xs, f) {
    return __awaiter(this, void 0, void 0, function () {
        var results, reducer;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    results = [];
                    reducer = function (p, x, i) {
                        return p.then(function () { return f(x, i, xs); }).then(function (z) { return results.push(z); });
                    };
                    return [4 /*yield*/, xs.reduce(reducer, Promise.resolve())];
                case 1:
                    _a.sent();
                    return [2 /*return*/, results];
            }
        });
    });
}
/**
 * Async function map.
 * Invokes `f` for each `x` in `xs` concurrently, up to `options.concurrency`
 * at a time.
 *
 * @example
 * mapAsync([1, 2, 3], async () => { ... })
 * mapAsync([1, 2, 3], someAsyncFunction, { concurrency: 10 })
 */
export function mapAsync(xs, f, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.concurrency, concurrency = _c === void 0 ? Infinity : _c;
    var chunks = chunk(xs, concurrency);
    return mapSeriesAsync(chunks, function (c) { return Promise.all(c.map(f)); }).then(flatten);
}
/**
 * Creates an async tappable function for easy side-effect operations.
 * Returns a function that invokes `f` with the given arguments, awaits it's
 * returns, then returns the first argument.
 *
 * @example
 * const five == await getNumberFiveAsync()
 *   .then(tapsAsync(operationA))
 *   .then(tapsAsync(operationB))
 *
 * // five === 5
 */
export function tapsAsync(f) {
    var _this = this;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, f.apply(void 0, __spread(args))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, args[0]];
                }
            });
        });
    };
}
/**
 * Invokes the given function until a falsy value is returned up to
 * `options.maxAttempts` times (with a delay of `options.delayMS` in between
 * invocations).
 *
 * @example
 * const hasTimedOut = await invokeWhile(() => false, {
 *   delayMs: 1000,
 *   maxAttempts: 3,
 * })
 *
 * // => hasTimedOut === false, func invoked once
 *
 * const hasTimedOut = await invokeWhile(() => true, {
 *   delayMs: 1000,
 *   maxAttempts: 3,
 * })
 *
 * // => hasTimedOut === true, func invoked 3 times
 */
export function invokeWhile(func, _a) {
    var n = _a.delayMs, _b = _a.maxAttempts, maxAttempts = _b === void 0 ? 3 : _b;
    function attempt(i) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (i >= maxAttempts)
                            return [2 /*return*/, true];
                        return [4 /*yield*/, func()];
                    case 1:
                        if (!(_a.sent()))
                            return [2 /*return*/, false];
                        return [2 /*return*/, delay(n).then(function () { return attempt(i + 1); })];
                }
            });
        });
    }
    return attempt(0);
}
/**
 * Invokes the given function "forever" with a delay of `options.delayMS` in
 * between invocations. Returns a function to cancel the forever loop.
 *
 * @example
 * const stopPollingAPI = await invokeForever(startPollingAPI, {
 *   delayMs: 1000 * 10,
 * })
 *
 * if (useHasLoggedOut) {
 *   stopPollingAPI()
 * }
 */
export function invokeForever(func, _a) {
    var _this = this;
    var delayMs = _a.delayMs;
    var cancelled = false;
    var iteratee = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, cancelled ? false : Promise.resolve().then(func).then(T)];
        });
    }); };
    invokeWhile(iteratee, {
        delayMs: delayMs,
        maxAttempts: Infinity,
    });
    return function () {
        cancelled = true;
    };
}
//# sourceMappingURL=async.js.map